import { useAdminStore } from '../../store/adminStore'
import type { ToastType } from '../../types'

const ICONS: Record<ToastType, string> = {
  success: '✓',
  error:   '✕',
  info:    'i',
  warning: '!',
}

export function ToastContainer() {
  const { toasts, removeToast } = useAdminStore()

  return (
    <>
      <div className="toast-container" role="region" aria-label="Notifications">
        {toasts.map((t) => (
          <div key={t.id} className={`toast toast--${t.type}`}>
            <span className="toast-icon">{ICONS[t.type]}</span>
            <span className="toast-msg">{t.message}</span>
            <button
              className="toast-dismiss"
              onClick={() => removeToast(t.id)}
              aria-label="Dismiss"
            >✕</button>
          </div>
        ))}
      </div>

      <style>{`
        .toast-container {
          position: fixed;
          bottom: 24px;
          right: 24px;
          display: flex;
          flex-direction: column;
          gap: 8px;
          z-index: 200;
          max-width: 380px;
          width: calc(100vw - 48px);
        }
        .toast {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px 14px;
          border-radius: var(--radius-md);
          border: 1px solid transparent;
          box-shadow: var(--shadow-md);
          font-size: 0.875rem;
          animation: toast-in 0.2s ease;
        }
        @keyframes toast-in {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .toast--success { background: var(--bg-success); border-color: var(--color-success); color: var(--color-success); }
        .toast--error   { background: var(--bg-error);   border-color: var(--color-error);   color: var(--color-error); }
        .toast--info    { background: var(--bg-info);    border-color: var(--color-info);    color: var(--color-info); }
        .toast--warning { background: var(--bg-warning); border-color: var(--color-warning); color: var(--color-warning); }
        .toast-icon {
          font-size: 0.75rem;
          font-weight: 700;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1.5px solid currentColor;
          flex-shrink: 0;
        }
        .toast-msg { flex: 1; color: var(--text-primary); line-height: 1.4; }
        .toast-dismiss {
          color: var(--text-muted);
          font-size: 0.7rem;
          padding: 2px 4px;
          flex-shrink: 0;
          transition: color 0.15s;
        }
        .toast-dismiss:hover { color: var(--text-primary); }
      `}</style>
    </>
  )
}
